import { PageId, WidgetId } from 'types/idTypes';
import { Subset } from 'types/object.types';
import { BackgroundPattern, Gradient } from 'types/pageTypes';
import { Widget } from 'types/widget.types';
import { AllWidgetData } from 'widgets/Widget.types';

export enum WidgetDirection {
  Up = 'up',
  Down = 'down',
  Front = 'front',
  Back = 'back',
}

export type AddGroupWidget = {
  widgetId: WidgetId;
  widgetData: AllWidgetData;
  groupWidgets?: AddGroupWidget[];
};

export type AddWidget = {
  pageId: PageId;
  widgetId: WidgetId;
  widgetData: AllWidgetData;
  groupWidgets?: AddGroupWidget[];
  isResponsiveGroup?: boolean;
  positionedNextTo?: WidgetId;
};

export type UpdatePageBackground = {
  pageId: PageId;
  background?: string;
  gradientBackground?: Gradient | null;
  backgroundPattern?: BackgroundPattern;
};

export type UpdateWidget = {
  widgetId: WidgetId;
  widgetData: Subset<AllWidgetData>;
};

export type PreviousWidgetInfo = {
  widgetId: WidgetId;
  widgetData: Widget;
  pageId: PageId;
};
